<template lang="html">
  <div class="tabs-container">
    <div class="tabs">
      <div
        v-for="(heading, index) in headings"
        class="tab tab-heading"
        :class="{ 'is-active': index === activeIndex }"
        :key="`tab-${index}`"
        @click="slideToTab(index)">
        {{heading}}
      </div>
    </div>

    <div class="tab-container" :style="{height: tabHeight}">
      <div
        class="tab-inner"
        :style="{ width: this.containerWidth, transform: this.transform }">

        <slot/>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  data() {
    return {
      transform: '0%',
      activeIndex: 0,
      tabHeight: ''
    }
  },

  props: {
    headings: Array
  },

  computed: {
    totalTabs() {
      return this.headings.length
    },

    containerWidth() {
      return 100 * this.totalTabs + '%'
    },

    itemWidth() {
      return 100 / this.totalTabs
    }
  },

  methods: {
    slideToTab(index) {
      this.activeIndex = index
      this.transform = `translateX(-${this.itemWidth * index}%)`
      this.setHeight(index)
    },

    setHeight(index) {
      const padding = 20
      let tabs = document.querySelectorAll('.tab-inner .tab')
      let activeTabHeight = tabs[index].children[0].offsetHeight

      this.tabHeight = `${activeTabHeight + padding}px`
    },

    initTab() {
      window.setTimeout(() => {
        const firstTab = 0
        this.slideToTab(firstTab)
        this.setHeight(firstTab)
      }, 2000)
    }
  },

  mounted() {
    this.initTab()
  },

  watch: {
    $route() {
      this.initTab()
    }
  }
}
</script>

<style lang="sass">
  @import '../stylesheets/base/variables'
  @import '../stylesheets/base/theme'
  @import '../stylesheets/helpers/mixins'

  .tabs-container
    .tabs
      position: relative
      display: flex
      justify-content: flex-start
      margin-bottom: $gap-small
      border-bottom: 2px solid $color-border-light
      padding-bottom: $gap-small
      position: sticky
      top: 0
      z-index: 1
      background: rgba(255, 255, 255, 0.95)

      &:before
        content: ''
        background: rgba(255, 255, 255, 0.95)
        position: absolute
        top: -20px
        left: 0
        width: 100%
        height: 20px
        pointer-events: none

    .tab
      width: 100%
      padding: 3px 2px

    .tab-heading
      text-align: center
      opacity: 0.25
      cursor: pointer
      font-family: $font-bold
      transition: opacity .3s ease-in-out
      text-transform: uppercase

      &.is-active
        position: relative
        opacity: 1

        @include themify($themes)
          color: themed('color-secondary')

        &:before
          content: ''
          position: absolute
          width: 75%
          height: 2px
          bottom: -17px
          left: 50%
          transform: translateX(-50%)

          @include themify($themes)
            background: themed('color-secondary')

    .tab-container
      overflow: hidden
      transition: height .3s ease-in-out

    .tab-data
      width: 100%
      padding: 0

      ul
        padding: 0
        list-style: none
        margin-top: 0

        li
          display: flex
          justify-content: flex-start
          margin: 0 0 $gap-small 0

          &.tab-item
            display: none

    .key
      text-transform: capitalize

    .value
      font-weight: bold
      margin-left: $gap-small

    .tab-inner
      transition: transform .5s ease-in-out
      display: flex
</style>
